import { render } from "./Subscribe.vue?vue&type=template&id=27dc325c"
import script from "./Subscribe.vue?vue&type=script&lang=js"
export * from "./Subscribe.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/laravel/helpdeskada/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__